/* eslint-disable global-require */
const axios = require('axios')

async function createAdmin(token, name, email, password) {
  const resp = await axios.post('https://app.manyconvert.com/api/auth/register/admin', {
    name,
    email,
    password,
  })

  return resp
}

async function varifyToken(token) {
  const resp = await axios.get(`https://app.manyconvert.com/api/invite/check/token/${token}`)

  return resp.data
}

async function registerAttendent(name, email, password) {
  const resp = await axios.post('https://app.manyconvert.com/api/auth/register', {
    name,
    email,
    password,
  })

  return resp.data
}

async function registerAttendentStores(email, id, stores) {
  const userData = JSON.parse(localStorage.getItem('userData'))

  const resp = await axios.post(
    'https://app.manyconvert.com/api/attendants',
    {
      email,
      id,
      stores,
    },
    {
      headers: {
        Authorization: `Bearer ${userData.mc_access_token}`, // substitua conforme necessário
        'Content-Type': 'application/json',
      },
    },
  )

  return resp.data
}

async function aceitarConvite(token) {
  const userData = JSON.parse(localStorage.getItem('userData'))

  const resp = await axios.get(
    `https://app.manyconvert.com/api/invites/${token}/accept`,
    {
      headers: {
        Authorization: `Bearer ${userData.mc_access_token}`,
        'Content-Type': 'application/json',
      },
    },
  )

  return resp.data
}

async function registroIndicação(email, name, phone) {
  const resp = await axios.post(
    'https://bot.manyconvert.com/formmanyconvert',
    {
      phone,
      name,
      email,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return resp.data
}

async function registroIndicaçãoUser(phone, ecommerce) {
  const resp = await axios.put(
    'https://bot.manyconvert.com/formmanyconvert',
    {
      phone,
      ecommerce,
      platform: '',
      orders: '',
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return resp.data
}

module.exports = {
  registerAttendent, varifyToken, createAdmin, registerAttendentStores, aceitarConvite, registroIndicação, registroIndicaçãoUser,
}
